<template>
    <FixedHeader
        v-if="mounted"
        headerClass="IndustryHeader"
        fixedClass="is-fixed"
        :threshold="200"
    >
        <header>
            <div class="container">
                <IndustryLogo
                    :url="homepage"
                    :nav="true"
                />
                <DefaultNav
                    :nav="nav"
                    :spaceBetween="true"
                    enable-subnav
                />
                <NavToggle />
            </div>
        </header>
    </FixedHeader>
</template>
<script>
import FixedHeader from 'vue-fixed-header'

export default {
    name: 'IndustryHeader',
    components: {
        FixedHeader
    },
    props: {
        nav: {
            type: Array,
            default: null,
        },
        homepage: {
            type: String,
            default: '/',
        }
    },
    data() {
        return {
            mounted: false
        }
    },
    mounted() {
        this.mounted = true;
    }
}
</script>

<style lang="scss">
    @keyframes fadeIn {
        0% {
            opacity: 0;
            transform: translateY(-74px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .IndustryHeader {
        position: relative;
        width: 100vw;
        border-bottom: 1px solid $border-color;

        &.is-fixed {
            position: fixed;
            top: 0;
            z-index: 4;
            opacity: 0;
            animation: fadeIn 0.3s ease-out forwards;
        }

        @include media-query(desk) {
            &.is-fixed {
                background: getColor('white');
            }
        }

        > .container {
            justify-content: space-between;
            display: flex;

            @include media-query(desk) {
                align-items: center;
            }

            @include media-query(palm) {
                padding-right: 0;
                background: getColor('white');
            }
        }

        @include media-query(portable) {
            &:before {
                content: '';
                position: absolute;
                background: getColor('white');
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 3;
            }
        }
    }

    .IndustryHeader .DefaultNav {
        @include media-query(desk) {
            position: static;
            align-self: center;
        }

        @include media-query('(min-width: 1023px) and (max-width: 1216px)') {
            width: 100%;
            padding-left: 20px;
        }

        @include media-query(portable) {
            position: absolute;
            left: 0;
            align-self: flex-end;
        }
    }

    .IndustryHeader .NavToggle {
        @include media-query(portable) {
            position: relative;
            z-index: 3;
        }
    }

</style>

